import { writable, type Writable } from "svelte/store"

export const fantasySkin: Writable<boolean> = writable(false)
